import React from "react";

export function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="flex items-start justify-between mb-6" data-testid={testId}>
      <div>
        <div className="overline">{subtitle}</div>
        <h1 className="font-display font-bold text-3xl mt-1">{title}</h1>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function StatTile({ label, value, sub, testId, onClick }) {
  return (
    <div
      className={`gf-stat ${onClick ? "cursor-pointer hover:bg-zinc-50 transition-colors" : ""}`}
      data-testid={testId}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => { if (e.key === "Enter" || e.key === " ") onClick(); } : undefined}
    >
      <div className="gf-stat-label">{label}</div>
      <div className="gf-stat-value font-mono">{value}</div>
      {sub && <div className="gf-stat-sub">{sub}</div>}
    </div>
  );
}

// Smaller variant of StatTile for inline breakdown rows (Operations
// Console GP Reporting v2 breakdown, June 2026).
export function MicroTile({ label, value, primary = false, testId }) {
  return (
    <div
      className={`rounded border p-3 bg-white ${primary ? "border-emerald-400" : "border-zinc-200"}`}
      data-testid={testId}
    >
      <div className="overline text-[10px] leading-tight">{label}</div>
      <div className={`font-mono mt-1 ${primary ? "text-emerald-700 font-semibold" : "text-zinc-900"}`}>
        {value}
      </div>
    </div>
  );
}


export function Badge({ children, variant = "muted", testId }) {
  return (
    <span className={`gf-badge gf-badge-${variant}`} data-testid={testId}>
      {children}
    </span>
  );
}

export function EmptyState({ title = "No data yet", hint, action }) {
  return (
    <div className="py-16 text-center border border-dashed border-zinc-200 bg-white">
      <div className="overline mb-2">{title}</div>
      {hint && <div className="text-sm text-zinc-500">{hint}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function SectionPad({ children, className = "" }) {
  return <div className={`p-6 ${className}`}>{children}</div>;
}
